import clsx from 'clsx';

export function Money({ amount, currency = 'USD', sign, className }: { amount: number; currency?: string; sign?: boolean; className?: string }) {
  const isNeg = amount < 0;
  const formatted = new Intl.NumberFormat('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
    .format(Math.abs(amount));
  return (
    <span className={clsx('tnum tracking-tight', sign && (isNeg ? 'text-negative' : 'text-positive'), className)}>
      {sign ? (isNeg ? '\u2212' : '+') : ''}{formatted}
      <span className="text-muted ml-0.5 text-[0.85em]">{currency}</span>
    </span>
  );
}
